export const THIRD_SERVICES_API = {
  QY_WECHAT_ACCESSTOKEN: {
    url: "https://qyapi.weixin.qq.com/cgi-bin/gettoken",
    desc: "获取企业微信授权accesstoken ?corpid=ww0699392a9f40f9be&corpsecret=K4m28YCGphe_m_cVxKOVflvNizTotmIbF9OV5u09Cio",
  },
  QY_WECHAT_USERTICKET: {
    url: "https://qyapi.weixin.qq.com/cgi-bin/user/getuserinfo",
    desc: "获取企业微信userId tikect  ?access_token=zzzqsX6EtFSUS8STFIZavzcQ7ChryIABB3N7-1Taq3pMAZPVw0vl0u1u-w1jd4BERzy68Ce3f9DrqNDI_-gWOjAWz8Aw2itC4tVeEYFZZkH64XNwviuKNm-7eEQx9zCfFlA5TK5FCGHvpp-8Kgct2P3UgasuEhH8bcsQEGlagjTJS3eJPM23EXc5PAS-xhlm9Ovi4S_t9hmgdQIubcbflQ&code=UqYfYkP3aoBqGbAqtHFhzq-G-Wv-8-1RFWQ6T4vVlWE",
  },
};
export const SERVICES_API = {
  LOGIN: {
    url: "system/security/login",
    mockKey: "doLogin.json",
    desc: "登录接口",
  },
  LOGINOUT: {
    url: "system/security/logout",
    type: "post",
    desc: "退出登录接口",
  },
  QUERY_SYSTEMDATAS_VERSION: {
    url: "system/md/param/queryParamVersion",
    type: "get",
    mockKey: "querySystemDatasVersion.json",
    desc: "缓存的系统数据版本号，用于更新本地缓存的系统数据",
  },
  QUERY_CODELIST: {
    url: "system/ad/adLovList/queryCodeList",
    type: "get",
    mockKey: "queryCodeList.json",
    desc: "字典表接口",
  },
  QUERY_DOCKIND: {
    url: "system/bc/docKind/queryDocKind",
    type: "get",
    mockKey: "",
    desc: "单据类型接口",
  },
  QUERY_MDCITYS: {
    url: "system/md/mdDistrict/queryDistrictListForLookUp",
    // url: 'fsc/claim/ecPhone/queryPhoneFeeStd',
    type: "get",
    mockKey: "queryMdDistricts.json",
    desc: "城市数据",
  },
  QUERY_ECKINDFIELDS: {
    url: "fsc/base/bc/bceckindfield/queryEcKindFieldByUnitId",
    type: "get",
    mockKey: "queryEcKindField.json",
    desc: "动态字段",
  },
  QUERY_HOME_TEMINIT: {
    url: "system/bc/docKind/queryBcKindForApp",
    type: "get",
    mockKey: "",
    desc: "首页入口查询",
  },
  QUERY_HOME_INIT: {
    url: "fsc/claim/query/myclaim/queryIndexSummaryData",
    type: "get",
    mockKey: "queryInitPage.json",
    desc: "首页汇总数量查询",
  },
  QUERY_HOME_INMYAPPLY: {
    url: "fsc/ea/eaApplyGeneral/queryMyApplyList",
    type: "get",
    mockKey: "",
    desc: "首页列表申请在途",
  },
  QUERY_HOME_DRAFT_REIMBURSE: {
    url: "fsc/claim/query/drafts/queryResultSetByDtoApp",
    type: "get",
    mockKey: "",
    desc: "首页草稿箱-报账单",
  },
  QUERY_HOME_DRAFT_APPLY: {
    url: "fsc/ea/eaApplyGeneral/queryViewApplyAdvanceForDraft",
    type: "get",
    mockKey: "",
    desc: "首页草稿箱-申请单",
  },
  MY_CLAIM_LIST: {
    url: "fsc/claim/query/myclaim/queryResultSetByDtoForAppClaim",
    type: "get",
    mockKey: "queryMyClaim.json",
    desc: "我的报销列表",
  },
  GET_LOCAL_NOTIFICATIONS: {
    url: "？？？",
    type: "get",
    mockKey: "queryNotifications.json",
    desc: "获取通知",
  },
  ALLMESSAGE_LIST: {
    url: "system/md/bulletin/smBulletin/queryMessageGroupTitle",
    type: "get",
    mockKey: "queryMessageList.json",
    desc: "全部消息列表",
  },
  ALLMESSAGE_GROUP_LIST: {
    url: "system/md/bulletin/smBulletin/queryMessagesByType",
    type: "get",
    mockKey: "",
    desc: "单个消息组中的消息列表",
  },
  APPROVAL_LIST: {
    url: "appSystemAction/claim/queryMyHandleTask",
    type: "get",
    mockKey: "queryMyHandleTask.json",
    desc: "待办/乙办列表",
  },
  APPROVAL_DETAIL: {
    url: "appSystemAction/ecClaim/queryClaimByIdForApp",
    type: "get",
    mockKey: "queryClaimById.json",
    desc: "报账详情",
  },
  APPROVAL_DETAIL_BUDGET: {
    url: "fsc/budget/forecastExpense/queryClaimByIdForApp",
    type: "get",
    mockKey: "",
    desc: "待办列表详情-预算",
  },
  APPROVAL_DETAIL_PROJECT: {
    url: "fsc/project/pjProjectApply/queryPjProjectByIdForApp",
    type: "get",
    mockKey: "",
    desc: "待办列表详情-事项",
  },
  APPROVAL_DETAIL_CONTRACT: {
    url: "fsc/contract/contractapply/queryCmContractByIdForApp",
    type: "get",
    mockKey: "",
    desc: "待办列表详情-合同",
  },
  APPROVAL_DETAIL_OWNTOPAY: {
    url: "fsc/arrear/ecArrearApply/queryEcArrearByIdForApp",
    type: "get",
    mockKey: "",
    desc: "待办列表详情-订单",
  },
  ABOUT_TRAVEL_DETAIL: {
    url: "fsc/ea/eaApplyGeneral/queryApplyGeneralByIdForApp",
    type: "get",
    mockKey: "",
    desc: "差旅报账关联申请明细",
  },
  ABOUT_SHIXIANG_DETAIL: {
    url: "fsc/project/pjProjectApply/getPjProjectByIdForApp",
    type: "get",
    mockKey: "",
    desc: "关联事项明细",
  },
  ABOUT_CONTRACT_DETAIL: {
    url: "fsc/contract/contractapply/getCmContractDtoById",
    type: "get",
    mockKey: "",
    desc: "关联合同明细",
  },
  APPROVAL_CLAIM_ONE: {
    url: "system/rc/pwHandleTask/approveHandelTask",
    type: "post",
    mockKey: "",
    desc: "审批",
  },
  APPROVAL_CLAIM_MULTI: {
    url: "appSystemAction/claim/approveClaimForBatch",
    type: "get",
    mockKey: "",
    desc: "批量审批同意",
  },
  TRAVEL_APPLY_DETAIL: {
    url: "fsc/ea/eaApplyGeneral/queryApplyGeneralByIdForApp",
    type: "get",
    mockKey: "",
    desc: "申请单详情",
  },
  APPROVAL_VIEW_IMAGE: {
    url: "appSystemAction/ecClaim/viewImage",
    type: "post",
    mockKey: "",
    desc: "获取影像url",
  },
  SELECT_TICKET: {
    url: "appSystemAction/ecClaim/selectTicketPage",
    type: "post",
    mockKey: "",
    desc: "选票",
  },
  SET_TICKET: {
    url: "appSystemAction/ecClaim/completeEcItemByInvoiceBatckDto",
    type: "post",
    mockKey: "",
    desc: "选票结果传回后端",
  },
  TICKET_PACKAGE: {
    url: "appSystemAction/ecClaim/openTicketPackage",
    type: "post",
    mockKey: "",
    desc: "票夹",
  },
  TICKET_TO_DO: {
    url: "appSystemAction/ecClaim/rescanTodoPage",
    type: "post",
    mockKey: "",
    desc: "票夹",
  },
  XIECHENG_URL: {
    url: "api-ifs/travel/getUrl",
    type: "get",
    mockKey: "",
    desc: "携程机票，火车票，酒店，打车",
  },
  HW_URL: {
    url: "api-ifs/travel/getHwtripUrl",
    type: "get",
    mockKey: "",
    desc: "华为机票，火车票，酒店，打车",
  },
  IMAGE_PORT: {
    url: "adSysParamType/getAdSysParamDtoByTypeAndCode",
    type: "get",
    mockKey: "",
    desc: "postMessage端口号",
  },
  AD_SYSTEM_PARAM_GET_CODE: {
    url: "adSysParamType/queryAdSysParamToMap",
    type: "get",
    mockKey: "",
    desc: "获取系统参数",
  },
  QUERY_FLOW_HISTORY: {
    url: "appSystemAction/claim/queryFlowHistory",
    type: "post",
    mockKey: "",
    desc: "获取审批历史",
  },
  QUERY_TASK_STATUS: {
    url: "system/rc/pwHandleTask/ifHandingTask",
    type: "post",
    mockKey: "",
    desc: "代办获取参数状态",
  },
  ECDAILY_INIT: {
    url: "fsc/claim/ecdaily/addInit",
    type: "POST",
    mockKey: "",
    desc: "对私通用报账单初始化",
  },
  ECDAILY_SAVE_CLAIM: {
    url: "fsc/claim/ecdaily/saveClaim",
    type: "post",
    mockKey: "",
    desc: "通用报账保存",
  },
  ADD_BANKACCOUNT_LIST: {
    url: "???",
    type: "get",
    mockKey: "",
    desc: "新增银行账号",
  },
  UPDATE_BANKACCOUNT_LIST: {
    url: "???",
    type: "get",
    mockKey: "",
    desc: "更新银行账号",
  },
  DELETE_BANKACCOUNT: {
    url: "???",
    type: "get",
    mockKey: "",
    desc: "删除银行账号",
  },
  BANK_LIST: {
    url: "appSystemAction/mdBankAccount/queryByParamForApp",
    type: "get",
    mockKey: "",
    desc: "银行账号",
  },
  GET_DEFAULT_ACCOUNT: {
    url: "appSystemAction/mdBankAccount/getVendorDefaultAccount",
    type: "post",
    mockKey: "",
    desc: "收款账户",
  },

  ECPHONE_INIT: {
    url: "fsc/claim/ecPhone/addInit",
    type: "post",
    mockKey: "",
    desc: "个人通讯费的初始化",
  },
  ECPHONE_FEE_STD: {
    url: "fsc/base/bc/feeStandard/queryPhoneFeeStd",
    type: "get",
    mockKey: "",
    desc: "个人通讯费标准",
  },
  ECDAILY_SUBMIT_CLAIM: {
    url: "fsc/claim/ecdaily/submitClaim",
    type: "post",
    mockKey: "",
    desc: "通用报账提交",
  },
  COMMUNICATION_SAVE_CLAIM: {
    url: "fsc/claim/ecPhone/saveClaim",
    type: "post",
    mockKey: "",
    desc: "个人通讯费保存",
  },
  COMMUNICATION_SUBMIT_CLAIM: {
    url: "fsc/claim/ecPhone/submitClaim",
    type: "post",
    mockKey: "",
    desc: "个人通讯费提交",
  },

  TRAVEL_INIT: {
    url: "fsc/claim/ectravel/addInit",
    type: "post",
    mockKey: "",
    desc: "差旅报账的初始化",
  },
  MD_TRAVEL_DISTRICT_CLASSIFY: {
    url: "system/md/mdDistrict/queryDistrictClassify",
    type: "get",
    mockKey: "",
    desc: "差旅费用发生地分类",
  },
  MD_TRAVEL_FEES_STD: {
    url: "fsc/base/bc/feeStandard/queryTravelFeesStd",
    type: "get",
    mockKey: "",
    desc: "差旅标准",
  },
  MD_TRAVEL_SAVERECORD: {
    url: "fsc/claim/ectravel/saveClaim",
    type: "post",
    mockKey: "",
    desc: "差旅保存",
  },
  FSC_GET_DEFAULT_TRAVEL: {
    url: "fsc/claim/ectravel/getDefaultEcTravelByApplyId",
    type: "post",
    mockKey: "",
    desc: "获取申请单关联行程",
  },
  FSC_QUERY_TRAVEL_FEESSTD: {
    url: "fsc/claim/ectravel/queryTravelFeesStd",
    type: "post",
    mockKey: "",
    desc: "获取行程差旅标准",
  },
  MD_TRAVEL_SUBMIT: {
    url: "fsc/claim/ectravel/submitClaim",
    type: "post",
    mockKey: "",
    desc: "差旅提交",
  },
  QUERY_PRI_RULE: {
    url: "system/ad/adUserDataPri/getAdUserDataPriRuleList",
    type: "post",
    mockKey: "",
    desc: "权限查询",
  },
  QUERY_FI_RATE: {
    url: "fsc/base/bc/bcExchangeRate/queryExchangeRate",
    type: "get",
    mockKey: "",
    desc: "汇率查询",
  },

  // lookup ----- start
  FI_CENTER_LOOK: {
    url: "appSystemAction/bcFiEntity/queryBcFiEntityLookup",
    type: "get",
    mockKey: "",
    desc: "成本中心",
  },
  BD_ENTITY_LOOK: {
    url: "appSystemAction/BdEntity/searchBdEntity",
    type: "get",
    mockKey: "",
    desc: "承担部门",
  },
  MD_TAXRATE_LOOK: {
    url: "appSystemAction/MdTaxRate/searchMdTaxRate",
    type: "get",
    mockKey: "",
    desc: "税码",
  },
  EC_ITEM_LOOK: {
    url: "appSystemAction/BcEcItems/getBcEcItems",
    type: "get",
    mockKey: "",
    desc: "费用项目",
  },
  UNIT_NAME_LOOK: {
    url: "appSystemAction/bcFiBook/queryBcFiBookLookup",
    type: "get",
    mockKey: "",
    desc: "报账公司",
  },
  ENTITY_NAME_LOOK: {
    url: "system/md/mdEntity/getOrgEntitySelect",
    type: "get",
    mockKey: "",
    desc: "报账部门",
  },
  REIM_USER_LOOK: {
    url: "system/lookup/searchUserInfoCommonForLookup",
    type: "get",
    mockKey: "",
    desc: "报账人",
  },
  EAAPPLY_TRAVEL_LOOK: {
    url: "fsc/ea/eaApply/searchEaApplyForTravelLookup",
    type: "get",
    mockKey: "",
    desc: "关联申请单",
  },
  GET_BUDGET_CTRL: {
    url: "fsc/project/pjProject/getPjBudgetCtrlForLookUp",
    type: "get",
    mockKey: "",
    desc: "出差申请项目",
  },
  FSC_LOOKUP_GET_BUSSINESS_USER: {
    url: "api-fsc/fsc/lookup/getRcBusinessUserForLookupForApp",
    type: "get",
    mockKey: "",
    desc: "子项目",
  },
  GET_EC_ITEMS: {
    url: "system/lookup/getBcEcItemsForLookup",
    type: "get",
    desc: "出差申请预算项目",
  },
  SEARCH_ENTITY_PRIVILEGE: {
    url: "system/lookup/searchBdEntityForLookupForPrivilege",
    type: "get",
    desc: "出差申请预算部门",
  },
  MD_TRAVEL_EXCEED_LOOK: {
    url: "fsc/base/bc/bcStandardLevel/getExceedBcStandardLevel",
    type: "get",
    mockKey: "",
    desc: "超标工具",
  },
  MD_BANKACCOUNT_LIST_LOOK: {
    url: "appSystemAction/mdBankAccount/getMdBankAccountForLookup",
    type: "get",
    mockKey: "",
    desc: "选择收款账户列表",
  },
  MD_CURRENCY: {
    url: "appSystemAction/MdCurrency/getMdCurrencyForLookupSelect",
    type: "get",
    mockKey: "",
    desc: "币种",
  },
  // lookup ----- end
  QUERY_LOAN_OFFSET_LIST: {
    url: "fsc/claim/fiPsnLoan/selectFiPsnLoanOffSetResult",
    type: "get",
    mockKey: "",
    desc: "核销信息查询",
  },
  APPROVAL_DETAIL_EDIT: {
    // url: 'appSystemAction/ecClaim/queryClaimByIdForApp',
    url: "appSystemAction/ecClaim/editRecordForApp",
    type: "get",
    mockKey: "queryClaimById.json",
    desc: "报账详情-编辑",
  },
  ECENTERTAIN_INIT: {
    // url: 'appSystemAction/ecClaim/queryClaimByIdForApp',
    url: "fsc/claim/ecentertain/addInit",
    type: "post",
    mockKey: "getEcPhone.json",
    desc: "通讯费初始化",
  },
  COMMUNICATION_GET_YEARS: {
    url: "fsc/claim/ecPhone/getYearsAndMonthArr",
    type: "get",
    mockKey: "",
    desc: "通讯费报账明细查询已报销的年月",
  },
  TRAVEL_APPLY_INIT: {
    url: "fsc/ea/eaOrderTravelplanForSf/addInit",
    type: "get",
    mockKey: "",
    desc: "申请单初始化",
  },
  TRAVEL_APPLY_SAVE: {
    url: "fsc/ea/eaOrderTravelplanForSf/saveOrUpdate",
    type: "post",
    mockKey: "",
    desc: "申请单保存",
  },
  TRAVEL_APPLY_SUBMIT: {
    url: "fsc/ea/eaOrderTravelplanForSf/submitRecord",
    type: "post",
    mockKey: "",
    desc: "申请单提交",
  },
  TRAVEL_APPLY_CLOSE_LIST: {
    url: "fsc/ea/eaOrderTravelplan/queryEaOrderTravelPlan",
    type: "get",
    mockKey: "",
    desc: "申请单关闭列表",
  },
  TRAVEL_APPLY_CLOSE_LIST_CLOSE: {
    url: "fsc/ea/eaOrderTravelplan/saveOrUpdateForClose",
    type: "post",
    mockKey: "",
    desc: "申请单关闭",
  },
  TRAVEL_APPLY_SUMMARIZE_GET_DATA: {
    url: "fsc/ea/eaInformationPool/queryRecord",
    type: "post",
    mockKey: "",
    desc: "出差总结初始化接口",
  },
  TRAVEL_APPLY_CONCLUSION_SAVE_UPDATE: {
    url: "fsc/ea/eaInformationPool/saveOrUpdate",
    type: "post",
    mockKey: "",
    desc: "出差总结修改保存接口",
  },
  TRAVEL_APPLY_CONCLUSION_DELETE: {
    url: "fsc/ea/eaInformationPool/deleteMultiForApp",
    type: "post",
    mockKey: "",
    desc: "出差总结删除接口",
  },
  TRAVEL_APPLY_CONCLUSION_FUJIAN: {
    url: "system/ad/adAffix/selectByParam",
    type: "post",
    mockKey: "",
    desc: "出差总结附加接口",
  },
  GET_FIBOOK: {
    url: "system/lookup/queryBcFiBookLookup",
    type: "get",
    mockKey: "",
    desc: "获取记账公司",
  },
  COST_CLASSIFY: {
    url: "system/lookup/selectMdDistrictClassifyForLookup",
    type: "get",
    mockKey: "",
    desc: "获取区域分类",
  },
  MD_PAYMENTTYPE_LIST_LOOK: {
    url: "system/md/mdPaymentMode/getMdPaymentModes",
    type: "get",
    mockKey: "",
    desc: "结算方式/付款方式",
  },
  MD_BANK_ACCOUNT_LOOK: {
    url: "system/lookup/getMdBankAccountForLookup",
    type: "get",
    mockKey: "",
    desc: "银行帐号",
  },
  MD_CORP_LIST: {
    url: "system/lookup/getMdCorpForLookupSelect",
    type: "get",
    mockKey: "",
    desc: "结算单位",
  },
  MD_VEHICLE_LOOK: {
    url: "system/lookup/searchVehicleForLookup",
    type: "get",
    mockKey: "",
    desc: "交通工具",
  },
  QUERY_HOME_DRAFT_LOAN_REPAY: {
    url: "fsc/claim/query/drafts/queryLoanPayOffApp",
    type: "get",
    mockKey: "",
    desc: "首页草稿箱-借还款单",
  },
  DELETE_HOME_DRAFT_APPLY: {
    url: "fsc/ea/eaApply/deleteMultiClaim",
    // url: 'fsc/ea/eaOrderTravelplan/deleteMultiClaim',
    type: "post",
    mockKey: "",
    desc: "草稿箱-申请单删除",
  },
  DELETE_HOME_DRAFT_APPLY_INVALID: {
    url: "fsc/ea/eaApply/invalidClaim",
    type: "post",
    mockKey: "",
    desc: "草稿箱-申请单作废",
  },
  DELETE_HOME_DRAFT_REIMBURSE: {
    url: "appSystemAction/ecClaim/deleteMultiClaimNew",
    type: "post",
    mockKey: "",
    desc: "草稿箱-报账单-借还款-删除",
  },
  DELETE_HOME_DRAFT_INVALID: {
    url: "appSystemAction/ecClaim/invalidClaim",
    type: "post",
    mockKey: "",
    desc: "草稿箱-报账单-借还款-作废",
  },
  APPROVAL_CONNECT_CANCEL: {
    url: "system/rc/workflow/cancleConnect",
    type: "post",
    mockKey: "",
    desc: "取消沟通",
  },
  APPLY_DETAIL: {
    // url: 'fsc/ea/eaApplyGeneral/queryApplyGeneralByIdForApp',
    url: "fsc/ea/eaApply/viewRecordForApp",
    type: "get",
    mockKey: "",
    desc: "申请单详情",
  },
  EA_ORDER_TRAVELPLAN_EDIT_FORAPP: {
    url: "fsc/ea/eaOrderTravelplan/editRecordForApp",
    type: "get",
    mockKey: "",
    desc: "申请单详情-编辑",
  },
  EA_ORDER_TRAVELPLAN_VIEW_FORAPP: {
    url: "fsc/ea/eaOrderTravelplan/viewRecordForApp",
    type: "get",
    mockKey: "",
    desc: "申请单详情-编辑",
  },
  TRAVEL_VISIT_SYNC: {
    url: "fsc/claim/ifCustomerVisit/queryByParam",
    type: "get",
    mockKey: "",
    desc: "同步客户拜访信息",
  },
  ECCAR_INIT: {
    url: "fsc/claim/ecppcar/addInit",
    type: "post",
    mockKey: "",
    desc: "私车公用报账的初始化",
  },
  ECCAR_SAVERECORD: {
    url: "fsc/claim/ecppcar/saveClaim",
    type: "post",
    mockKey: "",
    desc: "私车公用报账保存",
  },
  ECCAR_VEHICLEFEESTD: {
    url: "fsc/base/bc/feeStandard/queryVehicleFeeStd",
    type: "get",
    mockKey: "",
    desc: "私车公用标准",
  },
  EC_FIND_ADAMT: {
    url: "fsc/budget/forecastExpense/findAdAmt",
    type: "post",
    mockKey: "",
    desc: "预算可用额",
  },
  ECCAR_SUBMIT: {
    url: "fsc/claim/ecppcar/submitClaim",
    type: "post",
    mockKey: "",
    desc: "私车公用报账提交",
  },
  ENTERTAIN_INIT: {
    url: "fsc/claim/ecentertain/addInit",
    type: "post",
    mockKey: "",
    desc: "业务招待填单初始化",
  },
  ENTERTAIN_SAVERECORD: {
    url: "fsc/claim/ecentertain/saveOrUpdateRecord",
    type: "post",
    mockKey: "",
    desc: "业务招待填单保存",
  },
  ENTERTAIN_SUBMIT: {
    url: "fsc/claim/ecentertain/submitClaim",
    type: "post",
    mockKey: "",
    desc: "业务招待填单提交",
  },
  REIMBURSEMENT_LIST: {
    url: "fsc/claim/query/drafts/queryPayOffApp",
    type: "get",
    mockKey: "",
    desc: "我的还款列表",
  },
  REIMBURSEMENT_INIT: {
    url: "fsc/claim/ecPayoff/addInit",
    type: "post",
    mockKey: "",
    desc: "还款初始化",
  },
  REIMBURSEMENT_SAVERECORD: {
    url: "fsc/claim/ecPayoff/saveOrUpdateByDto",
    type: "post",
    mockKey: "",
    desc: "还款保存",
  },
  REIMBURSEMENT_SUBMIT: {
    url: "fsc/claim/ecPayoff/submitClaim",
    type: "post",
    mockKey: "",
    desc: "还款提交",
  },
  LOAN_LIST: {
    url: "fsc/claim/query/drafts/queryLoanApp",
    type: "get",
    mockKey: "",
    desc: "我的借款列表",
  },
  LOAN_INIT: {
    url: "fsc/claim/ecLoan/addInit",
    type: "post",
    mockKey: "",
    desc: "借款初始化",
  },
  LOAN_SAVERECORD: {
    url: "fsc/claim/ecLoan/saveOrUpdateEcLoan",
    type: "post",
    mockKey: "",
    desc: "借款保存",
  },
  LOAN_SUBMIT: {
    url: "fsc/claim/ecLoan/submitRecord",
    type: "post",
    mockKey: "",
    desc: "借款提交",
  },
  SETUP_URGENT: {
    url: "appSystemAction/ecClaim/setUpUrgent",
    type: "post",
    mockKey: "",
    desc: "加急",
  },
  SETUP_CALLBACK_APPLY: {
    url: "fsc/ea/eaOrderTravelplan/undoTaskRecord",
    type: "post",
    mockKey: "",
    desc: "撤回-申请单",
  },
  SETUP_CALLBACK: {
    url: "appSystemAction/ecClaim/callBackClaim",
    type: "post",
    mockKey: "",
    desc: "撤回-报账单",
  },
  CHANGEUSERROLE: {
    url: "system/security/changeLoginRole",
    type: "get",
    mockKey: "",
    desc: "切换组织",
  },
  MD_PAY_CONDITION_LOOK: {
    url: "system/lookup/selectBcSapPayConditionForLookup",
    type: "get",
    mockKey: "",
    desc: "付款条件",
  },
  MD_INVOICE_LIST_LOOK: {
    url: "fsc/invoice/ftInvoice/queryFtInvoicesForLookUp",
    type: "get",
    mockKey: "",
    desc: "发票池",
  },
  MD_BRAND_LOOK: {
    url: "system/lookup/selectMdBrandForLookup",
    type: "get",
    mockKey: "",
    desc: "品牌",
  },
  MD_PRODEDUCT_LINE_LOOK: {
    url: "system/lookup/selectMdProdLineForLookup",
    type: "get",
    mockKey: "",
    desc: "产品线",
  },
  MD_INNER_ORDER_LOOK: {
    url: "system/lookup/selectBcSapOrderForLookup",
    type: "get",
    mockKey: "",
    desc: "内部订单",
  },
  MD_UNITSEL_LOOK: {
    url: "system/lookup/getUnitSelect",
    type: "get",
    mockKey: "",
    desc: "内部垫付单位/报账公司",
  },
  MD_PAYCONDATION_LOOK: {
    url: "system/lookup/selectBcSapPayConditionForLookup",
    type: "get",
    mockKey: "",
    desc: "付款条件",
  },
  MD_FIBOOK_COMPANY_LOOK: {
    url: "system/lookup/queryBcFiBookLookup",
    type: "get",
    mockKey: "",
    desc: "记账公司",
  },
  MD_APPROVAL_SELPERSON: {
    url: "system/lookup/selectSignUserForLookup",
    type: "get",
    mockKey: "",
    desc: "沟通 加签 转办 选择人员",
  },
  MD_PAYMENTMODES_LOOK: {
    url: "system/lookup/getMdPaymentModes",
    type: "get",
    mockKey: "",
    desc: "付款方式",
  },
  USER_ROLE_LIST: {
    url: "system/lookup/serachUserInfoByRoleForLookup",
    type: "get",
    mockKey: "",
    desc: "根据角色code展示用户，直线经理，部门经理",
  },
  // lookup ----- end
  UPDATE_INV_STATUS: {
    url: "fsc/invoice/ftInvoice/updateFtInvoiceStatus",
    type: "post",
    mockKey: "",
    desc: "发票列表停用方法",
  },
  GET_ANNEX_INFO: {
    url: "ad/affix/adAffix/queryAdAffixList",
    type: "get",
    mockKey: "",
    desc: "获取样机申请单的附件信息",
  },
  BANK_ACCOUNT_TRAIL: {
    url: "system/md/bank/mdBankAccountTrail/viewForApp",
    type: "post",
    mockKey: "",
    desc: "获取创建公司银行账号",
  },
  SEARCH_BUSSINESS_EAS: {
    url: "system/gxLookup/searchAssistDataForLookup",
    type: "get",
    mockKey: "",
    desc: "获取业务类型EAS",
  },
  QUERY_NODE_ACT: {
    url: "system/rc/wfFlowNodeAct/queryNodeAct",
    type: "post",
    mockKey: "",
    desc: "获取分管领导请求参数",
  },
  SELECT_SIGN_USER: {
    url: "system/lookup/selectSignUserForLookup",
    type: "get",
    mockKey: "",
    desc: "获取分管领导",
  },
  SAVE_SIGN_USER: {
    url: "system/rc/wfFlowNodeAct/saveUpdateNodeAct",
    type: "post",
    mockKey: "",
    desc: "保存分管领导",
  },
  QUERY_TRAVEL_FEE_STD: {
    url: "fsc/base/bc/feeStandard/queryTravelFeesStd",
    type: "get",
    mockKey: "",
    desc: "获取差旅费用标准",
  },
  SYS_SECURITY_CHECKBYIAM: {
    url: "system/security/checkByIAM",
    type: "get",
    mockKey: "",
    desc: "获取系统参数",
  },
  FSC_EAINFORMATIONDESC: {
    // url: 'appSystemAction/ecClaim/queryClaimByIdForApp',
    url: "fsc/ec/eaInformationDesc/queryRecord",
    type: "post",
    mockKey: "",
    desc: "付款说明初始化",
  },
};



// WEBPACK FOOTER //
// ./src/config/services.url.config.ts